// Which housing providers' replies to naima@ have been opened on the dashboard, in this browser, so a new one shows green in
// Outreach and is counted on the Outreach tab until it is opened. Kept in the browser's storage as
// { providerId: time of the latest reply that was opened }; another browser or device keeps its own.

const KEY = 'rs360.admin.seenReplies';
const CHANGED = 'rs360:seen-replies';

/** When the provider last wrote to naima@. */
export const lastReplyAt = (row) => row.chain?.filter((email) => email.kind === 'received').at(-1)?.at ?? row.repliedAt;

/** The opened replies, or null before the first look in this browser. */
export function readSeen() {
  try {
    const seen = JSON.parse(window.localStorage.getItem(KEY));
    return seen && typeof seen === 'object' ? seen : null;
  } catch {
    return null;
  }
}

function writeSeen(seen) {
  try { window.localStorage.setItem(KEY, JSON.stringify(seen)); } catch { /* private browsing: forgotten on leaving */ }
  window.dispatchEvent(new window.Event(CHANGED));
}

/** A reply newer than the last one opened from that provider. Nothing is new before the first look (see `startSeen`). */
export const isNewReply = (row, seen) => Boolean(seen) && Boolean(row.repliedAt) && !(Date.parse(seen[row.providerId]) >= Date.parse(lastReplyAt(row)));

/** The first look in this browser counts every reply already there as read; after that it changes nothing. Answers the opened replies. */
export function startSeen(rows) {
  const seen = readSeen();
  if (seen) return seen;
  const now = Object.fromEntries(rows.filter((row) => row.repliedAt).map((row) => [row.providerId, lastReplyAt(row)]));
  writeSeen(now);
  return now;
}

/** Records that a provider's latest reply has been opened. Answers the opened replies. */
export function markSeen(row) {
  const next = { ...(readSeen() || {}), [row.providerId]: lastReplyAt(row) };
  writeSeen(next);
  return next;
}

/** Calls `listener` whenever the opened replies change, here or in another tab of this browser. Answers how to stop. */
export function onSeenChange(listener) {
  const fromOtherTab = (event) => { if (event.key === KEY) listener(); };
  window.addEventListener(CHANGED, listener);
  window.addEventListener('storage', fromOtherTab);
  return () => {
    window.removeEventListener(CHANGED, listener);
    window.removeEventListener('storage', fromOtherTab);
  };
}
